import { createReducer, createActions } from "reduxsauce";
import Immutable from "seamless-immutable";

const { Types, Creators } = createActions({
  getCheckAvailableRequest: [
    "leave_id",
    "student_id",
    "isTherapist",
    "isReschedule",
    "make_id",
    "therapist_leave_id",
  ],
  getCheckAvailableSuccess: ["checkAvailable"],
  getCheckAvailableFailure: null,
});

export const GetCheckAvailableTypes = Types;
export default Creators;

export const INITIAL_STATE = Immutable({
  checkAvailable: null,
  fetching: null,
  success: null,
  error: null,
  leave_id: null,
  student_id: null,
  isTherapist: null,
  isReschedule: null,
  make_id: null,
  therapist_leave_id: null,
});

export const GetCheckAvailableSelectors = {
  getData: (state: any) => state.getCheckAvailable.checkAvailable,
  isFetching: (state: any) => state.getCheckAvailable.fetching,
  isSuccess: (state: any) => state.getCheckAvailable.success,
  hasError: (state: any) => state.getCheckAvailable.error,
};

export const request = (state: any, { leave_id, student_id, isTherapist, isReschedule, make_id, therapist_leave_id }: any) => {
  const updateData = {
    fetching: true,
    success: null,
    error: null,
    leave_id,
    student_id,
    isTherapist,
    isReschedule,
    make_id,
    therapist_leave_id,
  };
  return state.merge ? state.merge(updateData) : { ...state, ...updateData };
};

export const success = (state: any, action: any) => {
  const { checkAvailable } = action;
  const updateData = {
    fetching: false,
    success: true,
    error: false,
    checkAvailable,
  };
  return state.merge ? state.merge(updateData) : { ...state, ...updateData };
};

export const failure = (state: any) => {
  const updateData = {
    fetching: false,
    success: false,
    error: true,
    checkAvailable: null,
  };
  return state.merge ? state.merge(updateData) : { ...state, ...updateData };
};

export const reducer = createReducer(INITIAL_STATE, {
  [Types.GET_CHECK_AVAILABLE_REQUEST]: request,
  [Types.GET_CHECK_AVAILABLE_SUCCESS]: success,
  [Types.GET_CHECK_AVAILABLE_FAILURE]: failure,
});
